import React from 'react';
import { authService } from '../../services/authService';

interface OAuthButtonProps {
  provider: 'discord' | 'google';
}

export const OAuthButton: React.FC<OAuthButtonProps> = ({ provider }) => {
  const handleClick = () => {
    const url = authService.getOAuthUrl(provider);
    window.location.href = url;
  };

  const label = provider === 'discord' ? 'Login with Discord' : 'Login with Google';
  const iconSrc = `/assets/images/auth/${provider}.png`;

  return (
    <button
      onClick={handleClick}
      style={{
        padding: '10px 16px',
        background: provider === 'discord' ? '#7289DA' : '#FFFFFF',
        color: provider === 'discord' ? 'white' : 'black',
        border: provider === 'google' ? '1px solid #dadce0' : 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold',
        marginTop: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        boxSizing: 'border-box'
      }}
    >
      <img src={iconSrc} alt={`${label} icon`} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
      <span style={{ width: '100%' }}>{label}</span>
    </button>
  );
};
